import { useRef } from "react";
import { useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";
import InfiniteScroll from "react-infinite-scroll-component";

const ComparatorSearcherResults = ({ isLoading, loadedFundList, setComparatorSlot, inputRef }) => {

    const [ isOpen, setIsOpen ] = useState(false);
    const [ displayResults, setDisplayResults ] = useState([]);
    const [ nextItemIndex, setNextItemIndex ] = useState(0);

    const comparatorSearcherResults = useRef(null);

    const loadMoreData = () => {
        if (isLoading || loadedFundList.length < 1) return;
        setDisplayResults((prevResults) => [...prevResults, loadedFundList.at(nextItemIndex)]);
        setNextItemIndex((prevIndex) => prevIndex + 1);
    };
    

    useEffect(() => {
        if(isLoading || loadedFundList?.length > 0) {
            setIsOpen(true)
        } else {
            setIsOpen(false)
        }
    }, [isLoading, loadedFundList])

    useEffect(() => {
        if (loadedFundList.length > 0 && comparatorSearcherResults?.current?.scrollHeight < 220 && nextItemIndex < loadedFundList.length) {
            loadMoreData();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [displayResults, loadedFundList.length, nextItemIndex]);
    

    useEffect(() => {
        if (loadedFundList.length < 1) {
            setDisplayResults([]);
            setNextItemIndex(0);
        }
        loadMoreData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loadedFundList]);

    const resultsOutsideClick = (event) => {
        if (!comparatorSearcherResults?.current?.contains(event.target)) {
            setIsOpen(false);
        }
    }

    const handleResultClick = (fundItem) => {
        setComparatorSlot(fundItem);
        setIsOpen(false);
        inputRef.current.value = "";
    }

    useEffect(() => {
        document.body.addEventListener('click', resultsOutsideClick);
        return () => {
            document.removeEventListener('click', resultsOutsideClick);
        };
    }, []);

    return(
        (isOpen || isLoading) &&
        <div id="comparator-searcher-results-scrollable"
            className={`comparator-searcher-results ${isLoading ? 'loading' : ''}`}
            ref={comparatorSearcherResults}>
            {isLoading && <div className="searcher-spinner"><Spinner animation="border" variant="danger" role="status"/></div>}
            <InfiniteScroll
                scrollableTarget="comparator-searcher-results-scrollable"
                dataLength={displayResults.length}
                next={loadMoreData}
                hasMore={nextItemIndex < loadedFundList.length}>
            {!isLoading && displayResults.length > 0 && displayResults?.map((fundItem, index) =>
                (<div
                    key={'searcher-item-' + index}
                    className="searcher-item"
                    onClick={() => {handleResultClick(fundItem)}}>{fundItem?.nombre}</div>)
            )}
            </InfiniteScroll>
        </div>
    )

}

export default ComparatorSearcherResults;